import Footer from './components/footer';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HakkimizdaMain from './components/hakkimizdamain';
import Header from './components/header';
import Navbar from './components/navbar';
import Slider from './components/slider';
import UrunlerMain from './components/urunlermain';
import Main from './pages/main';
import Hakkimizda from './pages/hakkimizda';
import Iletisim from './pages/iletisim';
import Galeri from './pages/galeri';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Navbar/>
        <Routes>
          <Route exact path="/" element={<Main/>}/>
          <Route exact path="/hakkimizda" element={<Hakkimizda/>}/>
          <Route exact path="/iletisim" element={<Iletisim/>}/>
          <Route exact path="/fotogaleri" element={<Galeri/>}/>
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
